import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

/** Nhãn + ô nhập của các form cài đặt (Cài đặt, Hoàn tất thông tin tài khoản). */
export function FieldRow({ label, hint, error, children, className }: {
  label: ReactNode
  hint?: string
  /** Lỗi của riêng ô này — hiện ngay dưới ô. */
  error?: string | null
  children: ReactNode
  className?: string
}) {
  return (
    <div className={cn('space-y-1', className)}>
      <Label>{label}{hint && <span className="text-muted text-xs font-normal ml-1">— {hint}</span>}</Label>
      {children}
      {error && <p className="text-xs text-danger" role="alert">{error}</p>}
    </div>
  )
}
